import { GridRowId, DataGridProProps } from '@mui/x-data-grid-pro';
import { useCallback, useState } from 'react';

export const useSingleExpand: () => Pick<
  DataGridProProps,
  'detailPanelExpandedRowIds' | 'onDetailPanelExpandedRowIdsChange'
> = () => {
  const [detailPanelExpandedRowIds, setDetailPanelExpandedRowIds] = useState<GridRowId[]>([]);

  const onDetailPanelExpandedRowIdsChange = useCallback((newIds: GridRowId[]) => {
    setDetailPanelExpandedRowIds(newIds.length > 1 ? [newIds[newIds.length - 1]] : newIds);
  }, []);

  return {
    detailPanelExpandedRowIds,
    onDetailPanelExpandedRowIdsChange
  };
};
